import React from 'react'
import { Helmet } from 'react-helmet';
import Seo from '../../components/Seo';
import BreadCrumb from './BreadCrumb';
import HeaderTwo from '../../components/header/HeaderTwo';
import Footer from '../../components/footer/Footer';
import RobloxArea from './RobloxArea';


function Skins() {
  return (
	<>
	<Helmet>
		<link rel="canonical" href="https://oliverandthetimemachine.com/roblox" />
		<title>OATTM - Roblox Skins</title>
		<meta name="description" content="Free roblox skins for the Oliver and the Time Machine series. All skins are free to use in Roblox." />
		
	</Helmet>
	<Seo 
		title="OATTM – Roblox Skins"
		description="Free roblox skins for the Oliver and the Time Machine series. All skins are free to use in Roblox."
		url="/roblox"
	/>
	 <HeaderTwo/>
     <main>
	 	<BreadCrumb/>
		<RobloxArea/>
	 </main>
	 <Footer/>
	</>
  )
}

export default Skins